import type { DonationsSummary } from "../../types"
import { Heading } from "@planningcenter/doxy-web"
import {
  formattedCents,
  roundCentsToNearestDollar,
} from "source/giving/utils/money"
import { css } from "@emotion/react"
import pluralize from "source/shared/pluralize"
import { useMediaQuery } from "source/giving/hooks/useMediaQuery"
import { BREAKPOINTS } from "source/shared/hooks/useWindowDimensions"

interface DonationsSummaryProps {
  donationsSummary: DonationsSummary
}

export default function DonationsSummary({
  donationsSummary,
}: DonationsSummaryProps) {
  const isMobile = useMediaQuery(`(max-width: ${BREAKPOINTS.XS - 1}px)`)
  const headingSize = isMobile ? 2 : 1

  return (
    <div
      className="action-drawer d-g jc-sb ai-fs"
      css={css`
        grid-template-columns: 1fr 1fr;
      `}
    >
      <div>
        <div className="fw-600 fs-13 c-brand">
          <div className="tt-u">Given this year</div>
          <Heading
            level={3}
            size={headingSize}
            color="tint1"
            text={formattedCents(
              roundCentsToNearestDollar(
                donationsSummary.current_year_donations_total_amount_cents,
              ),
            )}
          />
          {donationsSummary.current_year_in_kind_donations_count > 0 && (
            <div className="fs-5 fw-400 c-tint2">
              +{" "}
              {pluralize(
                donationsSummary.current_year_in_kind_donations_count,
                "in-kind donation",
              )}
            </div>
          )}
        </div>
      </div>
      <div>
        <div className="fw-600 fs-13 c-brand">
          <div className="tt-u">Given last year</div>
          <Heading
            level={3}
            size={headingSize}
            color="tint1"
            text={formattedCents(
              roundCentsToNearestDollar(
                donationsSummary.previous_year_donations_total_amount_cents,
              ),
            )}
          />
          {donationsSummary.previous_year_in_kind_donations_count > 0 && (
            <div className="fs-5 fw-400 c-tint2">
              +{" "}
              {pluralize(
                donationsSummary.previous_year_in_kind_donations_count,
                "in-kind donation",
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
